import { stat } from "fs";

const state = {
    has_heart_condition: null,
    has_asthma_condition: null,
    has_diabetes_condition: null,
    has_hearing_condition: null,
    has_allergies_condition: null,
    health_problems: null,
    is_on_medications: null,
    daily_medications: null,
    authorized_to_acetominophize: null,
    recent_surgeries: null
}

const mutations = {
    setHasHeartCondition(state, value) { state.has_heart_condition = value },
    setHasAsthmaCondition(state, value) { state.has_asthma_condition = value },
    setHasDiabetesCondition(state, value) { state.has_diabetes_condition = value },
    setHasHearingCondition(state, value) { state.has_hearing_condition = value },
    setHasAllergiesCondition(state, value) { state.has_allergies_condition = value },
    setHealthProblems(state, value) { state.health_problems = value },
    setIsOnMedications(state, value) { state.is_on_medications = value; if (state.is_on_medications === false){state.daily_medications=null;} },
    setDailyMedications(state, value) { state.daily_medications = value },
    setAuthorizedToAcetominophize(state, value) { state.authorized_to_acetominophize = value },
    setRecentSurgeries(state, value) { state.recent_surgeries = value }
}

export default {
    namespaced: true,
    state,
    mutations
}